export enum ManfrediteImportSource {
  DEV_STORY = 'devStory'
}

export type ImportSourceDto = {
  source: ManfrediteImportSource;
  username: string;
};
